import { compactNumber } from '@/utilities/Number';
import { LabelValue } from '@/types/label-value';

export interface Bar2DFusionChartConfig {
  animation?: string;
  theme?: string;
  showLegend?: boolean;
  forceYAxisValueDecimals?: boolean;
  decimals?: number;
  caption?: string;
  xAxisName?: string;
  yAxisName?: string;
  exportFilename?: string;
  paletteColors?: string[];
}

export interface FusionChartBar2D extends Partial<BarChart> {
  chart: Bar2DFusionChartConfig;
}

export interface BarChart {
  data : BarChartData[];
}

export interface BarChartData {
  label?: string,
  value: number,
  displayValue?: string,
  toolText?: string,
}

function defaultCompactFunction(d: LabelValue): BarChartData {
  const displayValue = compactNumber(d.value, { minimumFractionDigits: 0, maximumFractionDigits: (d.value ?? 0) < 1_000_000 ? 0 : 1 });

  return {
    ...d,
    displayValue: displayValue
  };
}

export async function compactDisplayValueForBarChart(ms: Promise<LabelValue[]>, compactFunction = defaultCompactFunction): Promise<BarChartData[]> {
  return ms.then(d=> d ? d.map(e => compactFunction(e)) : []);
}
